import * as yup from 'yup'

import helpers from 'helpers'

import constants from 'constants/index'

const { IMPORT_MAX_FILE_SIZE_MB } = constants.departments

const schema = yup.object().shape({
  file: yup
    .mixed()
    .test('fileRequired', 'Selecione uma planilha para importar', (value) =>
      helpers.validates.file.required(value),
    )
    .test(
      'fileSize',
      `O arquivo excede o limite de ${IMPORT_MAX_FILE_SIZE_MB} MB`,
      (value) =>
        helpers.validates.file.size('MB', IMPORT_MAX_FILE_SIZE_MB, value),
    ),
})

export default schema
